
































import { Barcode } from '@pos/interfaces/pos-v2';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import VueBarcode from 'vue-barcode';
import QrcodeVue from 'qrcode.vue';

@Component({
  name: 'bpc-pos-print-barcode',
  components: {
    barcode: VueBarcode,
    QrcodeVue,
  },
})
export default class PosPrintTicket extends Vue {
  @Prop({ type: Array, required: true }) readonly barcodes: Barcode[];

  get readyToShow(): boolean {
    return !!this.barcodes;
  }

  getQr(code): string {
    return `${code}`;
  }

  isQR(type: string): boolean {
    return type === 'qr';
  }

  isBarcode(type: string): boolean {
    return !this.isQR(type);
  }

  getBarcodeFormat(type: string): string {
    return type === 'upc_barcode' ? 'UPC' : 'CODE128';
  }
}
